import { defaultSettings } from './default-settings';
import { PLAY_TYPE_VALUES } from './compact-play-type';
import { CHANNEL_LAYOUT_VALUES } from './channel-layout-values';
import { THUMBNAIL_SPACING_PRESETS, THUMBNAIL_SPACING_VALUE_PER_PRESET } from './thumbnail-spacing-presets';
import { THUMBNAIL_BUTTONS_BEHAVIOR } from './thumbnail-buttons-behavior';
import { TEXT_ALIGNMENT_VALUES } from './text-alignment-values';
import { MAIN_ACTION_STYLE_TYPES } from './main-action-style-types';
export const defaultSettingsEditorX = {
  booleans: {
    ...defaultSettings.booleans,
    showChannelCategories: false,
    showSignIn: false,
    showVideoDurationInList: true,
    showVideoPublisherInList: false,
    showVideoDescriptionInList: true
  },
  numbers: {
    ...defaultSettings.numbers,
    channelLayout: CHANNEL_LAYOUT_VALUES.SLIDER_SMALL,
    thumbnailSpacing: THUMBNAIL_SPACING_VALUE_PER_PRESET[THUMBNAIL_SPACING_PRESETS.NARROW],
    thumbnailButtonsBehavior: THUMBNAIL_BUTTONS_BEHAVIOR.ON_HOVER,
    textAlignment: TEXT_ALIGNMENT_VALUES.LEFT,
    mainActionStyleType: MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT,
    mainItemOverlayOpacity: 40,
    thumbnailOverlayOpacity: 40,
    playType: PLAY_TYPE_VALUES.EXPANDED_VIEW
  },
  fonts: {
    ...defaultSettings.fonts
  },
  colors: {
    ...defaultSettings.colors,
    backgroundColor: {
      themeName: 'color-1',
      value: 'rgba(255,255,255,0)'
    },
    textColor: {
      themeName: 'color-5'
    }
  }
};
//# sourceMappingURL=default-settings-editor-x.js.map